import { FeStack } from 'errors/fe.error';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import { fromAnyDateToIso } from 'utils/converters/time/from.util';
import { nowAsIso } from 'utils/date/now.util';
import logger from 'utils/logger.util';
import isDateWorthy from 'utils/predicates/time/isDateWorthy.util';

const L = logger('LOCATION');

export const locationAssign = (options) => {
  const url = options?.url;
  try {
    window.location.assign(url);

    return true;
  } catch (e) {
    const tag = fromAnyToTrimmed(options?.tag);
    L.warn('locationAssign()', tag, url, e);
    return false;
  }
};

export const locationNew = (options) => {
  const url = options?.url;
  try {
    if (!url) {
      L.warn('locationNew()', 'Missing url:', url);
      return false;
    }

    window.open(url, '_blank', 'noopener noreferrer');

    return true;
  } catch (e) {
    const tag = fromAnyToTrimmed(options?.tag);
    L.warn('locationNew()', tag, url, e);
    return false;
  }
};

export const locationReplace = (options) => {
  const url = options?.url;
  try {
    window.location.replace(url);

    return true;
  } catch (e) {
    const tag = fromAnyToTrimmed(options?.tag);
    L.warn('locationReplace()', tag, url, e);
    return false;
  }
};

export const locationReload = (options) => {
  const tag = fromAnyToTrimmed(options?.tag);

  try {
    if (options instanceof FeStack) {
      const now = options?.now;
      L.debug('locationReload()', tag, now, options);
    } else {
      const now = isDateWorthy(options?.now) ? fromAnyDateToIso(options?.now) : nowAsIso();
      L.debug('locationReload()', tag, now, new FeStack({ tag, now }));
    }

    window.location.reload();

    return true;
  } catch (e) {
    L.warn('locationReload()', tag, options?.now, e);
    return false;
  }
};
